import { USER_TYPE } from "../../../utils/constant";

export const adminMenu = [
  {
    title: " ",
    list: [
      {
        icon: "icon-gauge",
        label: "Dashboard",
        pathname: "/dashboard",
        role: [],
      },
      {
        icon: "icon-forward-outline",
        label: "Request Config",
        pathname: "/requests",
        role: [USER_TYPE.ACCOUNT_DIRECTOR, USER_TYPE.ADMINSTRATOR, USER_TYPE.STANDARD],
      },
      {
        icon: "icon-briefcase-1",
        label: "Request management",
        pathname: "/applications",
        role: [],
      },
      {
        icon: "icon-users",
        label: "Users Management",
        pathname: "/users",
        role: [],
      },
      {
        icon: "icon-globe",
        label: "Company Management",
        pathname: "/companies",
        role: [USER_TYPE.ACCOUNT_DIRECTOR],
      },
      {
        icon: "icon-clipboard",
        label: "Department",
        pathname: "/departments",
        role: [USER_TYPE.ACCOUNT_DIRECTOR, USER_TYPE.ADMINSTRATOR],
      },
      {
        icon: "icon-file-text",
        label: "Reports",
        pathname: "/reports",
        role: [],
      },
    ],
  },
];

export const usersMenu = [
  {
    title: " ",
    list: [
      {
        icon: "icon-briefcase-1",
        label: "My Plot",
        pathname: "/parcels",
        role: [],
      },
      {
        icon: "icon-forward-outline",
        label: "Plot Applications",
        pathname: "/application",
        role: [],
      },
    ],
  },
];
